// extracted by mini-css-extract-plugin
export default {"wrapper":"Penetrate_wrapper__USrtd","title":"Penetrate_title__BNNx8"};